/**
 * A regra de QUANDO convidar a instalar o Orbind Desktop (SPEC-20260925-1628).
 *
 * Mora fora do componente porque é a única parte que dá para errar em silêncio
 * — e a única que dá para testar sem navegador. O componente cuida de pintar.
 */

const CHAVE_DISPENSA = 'orbind.convite-desktop'

/**
 * As quatro portas. Cada uma sozinha basta para NÃO oferecer.
 *
 * Separadas assim porque esquecer uma transforma um convite útil em incômodo
 * (aparecer para quem já tem instalado) ou em promessa vazia (oferecer um
 * instalador que não existe para aquele sistema).
 */
export function deveOferecerODesktop(estado: {
  /** Já está rodando dentro do app instalado. */
  noAppInstalado: boolean
  /** Já entrou alguma vez pelo desktop — carimbo do servidor. */
  usouDesktop: boolean
  /** Clicou em "Agora não desejo instalar" nesta sessão. */
  dispensou: boolean
  /** Existe instalador publicado para o sistema desta pessoa. */
  temInstalador: boolean
}): boolean {
  if (estado.noAppInstalado) return false
  if (estado.usouDesktop) return false
  if (estado.dispensou) return false
  return estado.temInstalador
}

/**
 * "Agora não desejo instalar" vale até o próximo LOGIN, decisão do usuário em
 * 2026-09-25. Guardar em `sessionStorage` é o que separa as duas coisas:
 * recarregar a página não traz o convite de volta (mesma sessão do navegador),
 * e entrar de novo traz — porque o logout esquece a dispensa.
 *
 * Guarda o `memberId`, e não um booleano: duas pessoas que se revezam no mesmo
 * computador não herdam a dispensa uma da outra.
 */
export function jaDispensouODesktop(memberId: string): boolean {
  try {
    return sessionStorage.getItem(CHAVE_DISPENSA) === memberId
  } catch {
    // aba anônima ou storage bloqueado: sem memória, o convite aparece
    return false
  }
}

export function guardarDispensaDoDesktop(memberId: string): void {
  try {
    sessionStorage.setItem(CHAVE_DISPENSA, memberId)
  } catch {
    // sem storage o convite volta no próximo carregamento — chato, não quebrado
  }
}

/** Chamado no logout: entrar de novo mostra o convite outra vez. */
export function esquecerDispensaDoDesktop(): void {
  try {
    sessionStorage.removeItem(CHAVE_DISPENSA)
  } catch {
    // nada a fazer
  }
}
